import axios from "axios";
import * as base from "./base.services";

export const create = (body: any) => {
  return axios.post(`${base.apiUrl}/client/contact_requests`, body);
};
